import { SxProps, Theme } from '@mui/system';

const styles = {
  title: {
    m: 1,
    mt: '15px',
    mb: '32px',
    fontSize: 18,
    fontWeight: '600',
  },
  autoCompleteContainer: {
    marginLeft: '15px',
  },
  codeContainer: {
    marginLeft: '7px',
  },
  autocomplete: {
    ml: 1,
    '& .MuiFormControl-root': {
      backgroundColor: 'secondary.main',
    },
  },
  textFieldStyle: {
    backgroundColor: 'secondary.main',
  },
  labelStyle: {
    marginBottom: '5px',
  },
  dropdownContainer: {
    ml: '18px',
  },
  deleteContainer: {
    justifyContent: 'flex-end',
    position: 'relative',
    alignItems: 'center',
  },
  checkboxContainer: {
    marginRight: '5px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
